import { apiClient } from '../client';
import type { CataloguesListParams, CataloguesListResponse } from './types';

// Query keys
export const cataloguesQueryKeys = {
  all: ['catalogues'] as const,
  lists: () => [...cataloguesQueryKeys.all, 'list'] as const,
  list: (params?: CataloguesListParams) => [...cataloguesQueryKeys.lists(), params] as const,
};

// API call
export async function getCatalogues(params?: CataloguesListParams): Promise<CataloguesListResponse> {
  const response = await apiClient.get<CataloguesListResponse>('/api/catalogues', { params });
  return response.data;
}
